/* AND — The & Edition */
(function () {
  'use strict';
  var AND = window.AND || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function savedSize() { try { return localStorage.getItem('and_size') || ''; } catch (e) { return ''; } }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    var f = d.querySelector('[data-drawer-close]');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('has-drawer');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Search panel (opens under the header, live results from /search/suggest) ---------- */
  (function () {
    var panel = $('[data-search-panel]');
    if (!panel) return;
    var header = panel.closest('.site-header');
    var overlay = $('.hsearch-overlay');
    var input = panel.querySelector('[data-search-input]');
    var def = panel.querySelector('[data-search-default]');
    var live = panel.querySelector('[data-search-live]');
    var timer = null, ctrl = null, lastQ = '';
    function open(e) {
      if (e) e.preventDefault();
      closeDrawers();
      panel.hidden = false; if (overlay) overlay.hidden = false;
      void panel.offsetWidth;
      panel.classList.add('is-open'); if (header) header.classList.add('is-searching');
      document.body.classList.add('has-search');
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      panel.classList.remove('is-open'); if (header) header.classList.remove('is-searching');
      document.body.classList.remove('has-search');
      setTimeout(function () { panel.hidden = true; if (overlay) overlay.hidden = true; }, 220);
    }
    function show(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var box = doc.querySelector('[data-ps-results]');
      live.innerHTML = box ? box.innerHTML : '';
      live.hidden = false; def.hidden = true;
    }
    function search() {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      if (!q) { live.hidden = true; def.hidden = false; return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      panel.classList.add('is-loading-results');
      var url = AND.routes.root.replace(/\/$/, '') + '/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + (panel.querySelectorAll('[data-search-default] .stile').length || 5) + '&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(show)
        .catch(function () {})
        .then(function () { panel.classList.remove('is-loading-results'); });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { open(e); return; }
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 220); });
  })();

  /* ---------- Header ---------- */
  var header = $('.site-header');
  if (header && header.classList.contains('is-transparent')) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Cart ---------- */
  function refreshCart(open) {
    return fetch(AND.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer-content')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-content'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-content]');
        var cur = $('[data-cart-content]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        if (window.ANDmarkMine) window.ANDmarkMine();
        var count = fresh ? fresh.getAttribute('data-count') : null;
        if (count !== null) $$('.cart-count').forEach(function (c) { c.textContent = count; c.setAttribute('data-count', count); });
        if (open) openDrawer('CartDrawer');
      });
  }
  window.ANDrefreshCart = refreshCart;

  function addToCart(form, btn) {
    var fd = new FormData(form);
    if (btn) btn.classList.add('is-loading');
    return fetch(AND.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(true); })
      .catch(function (err) {
        var msg = form.querySelector('[data-form-error]');
        if (msg) { msg.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; msg.hidden = false; }
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });

  function changeLine(line, qty) {
    var box = $('[data-cart-content]');
    if (box) box.classList.add('is-loading');
    return fetch(AND.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { return refreshCart(false); })
      .finally(function () { if (box) box.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (b) {
      e.preventDefault();
      var line = +b.getAttribute('data-line');
      var q = +b.getAttribute('data-qty');
      changeLine(line, Math.max(0, q));
    }
  });

  /* ---------- Product ---------- */
  $$('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = root.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[name=id]');
    var buy = root.querySelector('.buy');
    var priceEl = root.querySelector('[data-price]');
    var stickyPrice = $('[data-sticky-price]');
    var stickyVariant = $('[data-sticky-variant]');
    var addLabel = root.querySelector('[data-add-label]');
    var waBtn = root.querySelector('[data-wa-notify]');
    var waNumber = root.getAttribute('data-wa') || '';

    function money(cents) {
      var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.') + ' EGP';
    }
    function selected() {
      return $$('[data-option-index]', root).map(function (group) {
        var c = group.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || opts[i] === undefined || o === opts[i]; });
      });
    }
    function markAvailability() {
      var opts = selected();
      $$('[data-option-index]', root).forEach(function (group) {
        var idx = +group.getAttribute('data-option-index');
        $$('.size-pill', group).forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var test = opts.slice(); test[idx] = val;
          var v = findVariant(test);
          pill.classList.toggle('is-soldout', !v || !v.available);
        });
      });
    }
    function update() {
      var v = findVariant(selected());
      markAvailability();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = '<span class="price"><b>' + money(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price).replace(' EGP', '') + '</s><span class="chip chip--wine">' + (priceEl.getAttribute('data-promo') || '') + 'Save ' + money(v.compare_at_price - v.price).replace(' EGP', '') + '</span>' : '') + '</span>';
      }
      if (addLabel) addLabel.textContent = 'Add to bag · ' + money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stickyVariant) stickyVariant.textContent = v.title === 'Default Title' ? '' : v.title;
      if (buy) buy.classList.toggle('is-soldout', !v.available);
      var low = root.querySelector('[data-lowstock]');
      if (low) {
        var lowOn = v.available && typeof v.inv === 'number' && v.inv > 0 && v.inv <= +low.getAttribute('data-lowstock');
        low.hidden = !lowOn;
        if (lowOn) low.querySelector('span').textContent = 'Only ' + v.inv + ' left' + (v.title !== 'Default Title' ? ' in ' + v.title : '') + '. Order soon.';
      }
      if (waBtn && waNumber) {
        var text = 'Hi AND! Please let me know when ' + product.title + (v.title !== 'Default Title' ? ' (' + v.title + ')' : '') + ' is back in stock.';
        waBtn.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(text);
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    /* pair deal (1 & 1) */
    var pair = root.querySelector('[data-pair]');
    var pairColors = null;
    if (pair) { var pcj = pair.querySelector('[data-pair-colors]'); if (pcj) { try { pairColors = JSON.parse(pcj.textContent); } catch (e) {} } }
    function secondVariant(size) {
      var c = pairColors && pair.querySelector('input[name^="pair2color-"]:checked');
      var list = c && pairColors[c.value];
      if (list) return list.find(function (v) { return v.options[0] === size; });
      var opts = selected(); opts[0] = size;
      return findVariant(opts);
    }
    function pairMode() {
      var c = pair && pair.querySelector('input[name^="pair-"]:checked');
      return c && c.value === '2';
    }
    function refreshPair() {
      if (!pair) return;
      var on = pairMode();
      root.classList.toggle('is-pair', on);
      var v = findVariant(selected());
      var one = pair.querySelector('[data-one-price]');
      if (one && v) one.textContent = money(v.price);
      var oneCmp = pair.querySelector('[data-one-compare]'), oneTag = pair.querySelector('[data-one-tag]');
      var oneSave = v && v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
      if (oneCmp) { oneCmp.hidden = !oneSave; if (oneSave) oneCmp.textContent = money(v.compare_at_price).replace(' EGP', ''); }
      if (oneTag) { oneTag.hidden = !oneSave; if (oneSave) oneTag.textContent = (oneTag.getAttribute('data-promo') || '') + 'Save ' + money(oneSave).replace(' EGP', ''); }
      if (addLabel) addLabel.textContent = on ? 'Add 2 sets · ' + money(+pair.getAttribute('data-pair-total')) : (v ? 'Add to bag · ' + money(v.price) : addLabel.textContent);
      // mark sold-out sizes for set 2
      $$('[data-pair-second] .size-pill', pair).forEach(function (pill) {
        var pv = secondVariant(pill.querySelector('input').value);
        pill.classList.toggle('is-soldout', !pv || !pv.available);
      });
      var cc = pair.querySelector('input[name^="pair2color-"]:checked'), cn = pair.querySelector('[data-pair2-color-name]');
      if (cc && cn) cn.textContent = cc.getAttribute('data-name');
    }
    if (form) form.addEventListener('submit', function (e) {
      if (!pairMode()) return;
      e.preventDefault();
      e.stopPropagation();
      var v1 = findVariant(selected());
      var c2 = pair.querySelector('input[name^="pair2-"]:checked');
      var v2 = secondVariant(c2 ? c2.value : selected()[0]);
      var err = form.querySelector('[data-form-error]');
      if (!v1 || !v2 || !v1.available || !v2.available) {
        if (err) { err.textContent = 'One of the sizes you picked is sold out. Please choose another.'; err.hidden = false; }
        return;
      }
      if (err) err.hidden = true;
      var items = v1.id === v2.id ? [{ id: v1.id, quantity: 2 }] : [{ id: v1.id, quantity: 1 }, { id: v2.id, quantity: 1 }];
      var btn = form.querySelector('[type=submit]');
      btn.classList.add('is-loading');
      fetch(AND.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return refreshCart(true); })
        .catch(function (er) { if (err) { err.textContent = (er && er.description) || 'Something went wrong. Please try again.'; err.hidden = false; } })
        .finally(function () { btn.classList.remove('is-loading'); });
    });

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
      refreshPair();
    });
    var mine = savedSize();
    if (mine && !/[?&]variant=/.test(location.search)) {
      var group = root.querySelector('[data-option-index="0"]');
      var pick = group && $$('input', group).find(function (i) { return i.value === mine; });
      if (pick && !pick.checked) {
        var test = selected(); test[0] = mine;
        var pv = findVariant(test);
        if (pv && pv.available) pick.checked = true;
      }
    }
    update();
    if (pair && /[?&]pair=1\b/.test(location.search)) {
      var two = pair.querySelector('input[name^="pair-"][value="2"]');
      if (two && !two.checked) { two.checked = true; }
    }
    refreshPair();

    /* gallery */
    var track = root.querySelector('.gallery__track');
    var countEl = root.querySelector('[data-gallery-index]');
    var thumbs = $$('.gallery__thumbs button', root);
    if (track) {
      var slides = $$('.gallery__slide', track);
      var setActive = function (i) {
        if (countEl) countEl.textContent = i + 1;
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      };
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(slides.length - 1, i)));
      }, { passive: true });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
      });
    }

    /* sticky add to cart */
    var sticky = $('.sticky-atc');
    var mainBtn = root.querySelector('.buy__add');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
      var sBtn = sticky.querySelector('button');
      if (sBtn) sBtn.addEventListener('click', function () {
        if (buy && buy.classList.contains('is-soldout')) { root.scrollIntoView({ behavior: 'smooth' }); return; }
        if (form.requestSubmit) form.requestSubmit(); else addToCart(form, sBtn);
      });
    }
  });

  /* ---------- Find my size ---------- */
  function markMine() {
    var mine = savedSize();
    if (!mine) return;
    $$('.size-pill, .card__size').forEach(function (el) {
      var inp = el.querySelector('input');
      el.classList.toggle('is-mine', (inp ? inp.value : el.textContent.trim()) === mine);
    });
    $$('[data-sf-mine]').forEach(function (m) { m.hidden = false; m.querySelector('b').textContent = mine; });
  }
  window.ANDmarkMine = markMine;
  $$('[data-sf]').forEach(function (sf) {
    var overlay = sf.querySelector('[data-sf-overlay]');
    var modal = overlay.querySelector('.sf-modal');
    var root = sf.closest('[data-product]');
    var hEl = overlay.querySelector('[data-sf-h]'), wEl = overlay.querySelector('[data-sf-w]');
    var result = overlay.querySelector('[data-sf-result]');
    var sizeEl = overlay.querySelector('[data-sf-size]'), badge = overlay.querySelector('[data-sf-badge]');
    var note = overlay.querySelector('[data-sf-note]'), apply = overlay.querySelector('[data-sf-apply]');
    var soldNote = overlay.querySelector('[data-sf-soldout]');
    var fit = 'true', last = null;
    document.body.appendChild(overlay); // escape transformed / content-visibility parents
    try { var m = JSON.parse(localStorage.getItem('and_size_m') || '{}'); if (m.h) hEl.value = m.h; if (m.w) wEl.value = m.w; } catch (e) {}

    function open() { overlay.hidden = false; void overlay.offsetWidth; overlay.classList.add('is-open'); document.body.classList.add('has-drawer'); modal.focus(); }
    function close() { overlay.classList.remove('is-open'); document.body.classList.remove('has-drawer'); setTimeout(function () { overlay.hidden = true; }, 250); }
    sf.querySelector('[data-sf-open]').addEventListener('click', open);
    overlay.querySelector('[data-sf-close]').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

    $$('[data-sf-tab]', overlay).forEach(function (t) {
      t.addEventListener('click', function () {
        var name = t.getAttribute('data-sf-tab');
        $$('[data-sf-tab]', overlay).forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
        $$('[data-sf-panel]', overlay).forEach(function (p) { p.hidden = p.getAttribute('data-sf-panel') !== name; });
      });
    });
    $$('[data-fit]', overlay).forEach(function (b) {
      b.addEventListener('click', function () {
        fit = b.getAttribute('data-fit');
        $$('[data-fit]', overlay).forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b); });
      });
    });

    // Calibration kept from the original finder: size follows weight, height only adds a length note.
    // Bands (true to size): S 45-59 · M 60-71 · L 72-82 · XL 83-108. Confirmed by real M fits at 60, 63, 64 kg.
    var A = { weight: [[54, 0], [65, 1], [78, 2], [87, 3]], fitOffset: { snug: -0.35, 'true': 0, relaxed: 0.30 }, tallCm: 178, shortCm: 152, maxW: 108, minW: 45 };
    var SIZES = ['S', 'M', 'L', 'XL'];
    function interp(x, pts) {
      if (x <= pts[0][0]) return pts[0][1];
      if (x >= pts[pts.length - 1][0]) return pts[pts.length - 1][1];
      for (var i = 0; i < pts.length - 1; i++) { var a = pts[i], b = pts[i + 1]; if (x >= a[0] && x <= b[0]) return a[1] + (x - a[0]) / (b[0] - a[0]) * (b[1] - a[1]); }
      return pts[pts.length - 1][1];
    }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function show(size, text, mode) {
      last = size === '—' ? null : size;
      sizeEl.textContent = size; note.textContent = text;
      badge.textContent = mode === 'between' ? 'Between sizes' : mode === 'limit' ? 'Let’s check' : 'Recommended';
      badge.className = 'sf-badge' + (mode === 'between' ? ' is-between' : mode === 'limit' ? ' is-limit' : '');
      badge.style.display = last ? '' : 'none';
      result.hidden = false;
      apply.hidden = true; soldNote.hidden = true;
      if (last && root) {
        var pill = $$('[data-option-index="0"] input', root).find(function (i) { return i.value === last; });
        if (pill) {
          if (pill.closest('.size-pill').classList.contains('is-soldout')) {
            soldNote.hidden = false;
            soldNote.textContent = last + ' is sold out right now. Close this and tap “Notify me” to hear the moment it’s back.';
          } else { apply.hidden = false; apply.textContent = 'Select ' + last + ' and continue'; }
        }
      }
    }
    function recommend() {
      var h = parseFloat(hEl.value), w = parseFloat(wEl.value), bad = false;
      hEl.classList.remove('is-invalid'); wEl.classList.remove('is-invalid');
      if (!(h >= 120 && h <= 220)) { hEl.classList.add('is-invalid'); bad = true; }
      if (!(w >= 30 && w <= 200)) { wEl.classList.add('is-invalid'); bad = true; }
      if (bad) { show('—', 'Enter a height (120–220 cm) and weight (30–200 kg) to see your size.', 'between'); return; }
      try { localStorage.setItem('and_size_m', JSON.stringify({ h: h, w: w })); } catch (e) {}
      if (w > A.maxW) return show('XL', 'XL is our largest size, and at these measurements it may run snug. Message us before ordering and we’ll check the fit with you.', 'limit');
      if (w < A.minW) return show('S', 'S is our smallest size, and it may run loose at these measurements. Message us and we’ll help you find the right fit.', 'limit');
      var raw = clamp(interp(w, A.weight) + A.fitOffset[fit], 0, 3), idx = Math.round(raw), size = SIZES[idx];
      var len = '';
      if (h >= A.tallCm && idx < 3) len = ' You’re on the taller side. If you like a longer trouser, size up just for the pant length.';
      else if (h <= A.shortCm) len = ' The trousers may sit a little long, easy to hem if you prefer.';
      if (Math.abs(raw - idx) > 0.32) {
        var nb = clamp(raw > idx ? idx + 1 : idx - 1, 0, 3);
        if (nb !== idx) {
          var sm = SIZES[Math.min(idx, nb)], lg = SIZES[Math.max(idx, nb)];
          return show(size, 'You’re between ' + sm + ' and ' + lg + '. Pick ' + sm + ' for a closer fit, or ' + lg + ' for more room.' + len, 'between');
        }
      }
      show(size, 'A confident fit for your measurements.' + len, 'confident');
    }
    overlay.querySelector('[data-sf-go]').addEventListener('click', recommend);
    [hEl, wEl].forEach(function (el) { el.addEventListener('keydown', function (e) { if (e.key === 'Enter') recommend(); }); });
    apply.addEventListener('click', function () {
      if (!last) return;
      try { localStorage.setItem('and_size', last); } catch (e) {}
      var pill = root && $$('[data-option-index="0"] input', root).find(function (i) { return i.value === last; });
      if (pill) { pill.checked = true; pill.dispatchEvent(new Event('change', { bubbles: true })); }
      markMine();
      close();
    });
  });
  markMine();

  /* ---------- Cart: upgrade a piece to the full set ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-set-upgrade]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('is-loading'); b.disabled = true;
    var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    fetch(AND.routes.cartAdd + '.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-add'), quantity: 1 }] }) })
      .then(function (r) {
        if (!r.ok) throw r; // set no longer available: keep the piece in the bag
        return fetch(AND.routes.cartChange + '.js', { method: 'POST', headers: json, body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: Math.max(0, +b.getAttribute('data-keep')) }) });
      })
      .catch(function () {})
      .then(function () { return refreshCart(false); });
  });

  /* ---------- Reviews carousel (Judge.me renders its list after load, and again on sort/filter) ---------- */
  $$('[data-rev-carousel]').forEach(function (root) {
    var nav = root.querySelector('[data-rev-nav]');
    if (!nav) return;
    var bar = nav.querySelector('[data-rev-bar]'), prev = nav.querySelector('[data-rev-prev]'), next = nav.querySelector('[data-rev-next]');
    var track = null;
    function current() { return root.querySelector('.jdgm-masonry-grid__container'); }
    function sync() {
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth;
      var vis = Math.max(track.clientWidth / Math.max(track.scrollWidth, 1), 0.12);
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      if (bar) { bar.style.width = vis * 100 + '%'; bar.style.transform = 'translateX(' + ratio * (100 / vis - 100) + '%)'; }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      nav.hidden = false;
      nav.classList.toggle('is-static', max <= 2);
    }
    function attach() {
      var t = current();
      if (!t || t === track) { sync(); return; }
      track = t;
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    }
    function step() { var item = track && track.firstElementChild; return item ? item.getBoundingClientRect().width + 20 : 300; }
    if (prev) prev.addEventListener('click', function () { if (track) track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { if (track) track.scrollBy({ left: step(), behavior: 'smooth' }); });
    window.addEventListener('resize', sync);
    new MutationObserver(attach).observe(root, { childList: true, subtree: true });
    attach();
  });

  /* ---------- Hero message slider ---------- */
  $$('[data-hero-slider]').forEach(function (hero) {
    var slides = $$('[data-hero-slide]', hero);
    if (slides.length < 2) return;
    var cur = 0, timer = null, paused = false;
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === cur); sl.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
      $$('[data-hero-dot]', hero).forEach(function (d) { d.classList.toggle('is-active', +d.getAttribute('data-hero-dot') === cur); });
    }
    function start() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      clearInterval(timer);
      timer = setInterval(function () { if (!paused && !document.hidden) show(cur + 1); }, 6000);
    }
    hero.addEventListener('click', function (e) {
      var d = e.target.closest('[data-hero-dot]');
      if (d) { show(+d.getAttribute('data-hero-dot')); start(); }
    });
    hero.addEventListener('mouseenter', function () { paused = true; });
    hero.addEventListener('mouseleave', function () { paused = false; });
    hero.addEventListener('focusin', function () { paused = true; });
    hero.addEventListener('focusout', function () { paused = false; });
    show(0);
    start();
  });

  /* ---------- Campaign: "#black-friday" buttons fall back to all products when the offers section is not on the page ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#black-friday"]');
    if (a && !document.getElementById('black-friday')) { e.preventDefault(); window.location.href = (AND.routes.root || '/').replace(/\/$/, '') + '/collections/all'; }
  });

  /* ---------- Offer reel (Black Friday slider) ---------- */
  $$('[data-ofs]').forEach(function (root) {
    var slides = $$('[data-ofs-slide]', root);
    var bars = $$('[data-ofs-go]', root);
    var cur = root.querySelector('[data-ofs-cur]');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    if (slides.length < 2) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function go(k) {
      i = (k + slides.length) % slides.length;
      slides.forEach(function (sl, j) {
        var on = j === i;
        sl.classList.toggle('is-active', on);
        sl.setAttribute('aria-hidden', on ? 'false' : 'true');
        var b = sl.querySelector('.ofs__btn'); if (b) b.tabIndex = on ? 0 : -1;
      });
      bars.forEach(function (b, j) {
        b.classList.remove('is-active', 'is-done');
        if (j < i) b.classList.add('is-done');
      });
      if (bars[i]) { void bars[i].offsetWidth; bars[i].classList.add('is-active'); }
      if (cur) cur.textContent = pad(i + 1);
    }
    // the active bar's fill animation drives the timing, so pausing it pauses the reel
    bars.forEach(function (b) {
      b.addEventListener('click', function () { go(+b.getAttribute('data-ofs-go')); });
      var fill = b.querySelector('span');
      if (fill) fill.addEventListener('animationend', function () { if (b.classList.contains('is-active') && !still) go(i + 1); });
    });
    var prev = root.querySelector('[data-ofs-prev]'), next = root.querySelector('[data-ofs-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); });
    root.addEventListener('focusin', function () { root.classList.add('is-paused'); });
    root.addEventListener('focusout', function () { root.classList.remove('is-paused'); });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(i + 1); if (e.key === 'ArrowLeft') go(i - 1); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; root.classList.add('is-paused'); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      root.classList.remove('is-paused');
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    if (still) root.classList.add('is-still');
    go(0);
  });

  /* ---------- Notify-me boxes: the chosen color/size become customer tags and the WhatsApp text ---------- */
  $$('[data-notify]').forEach(function (box) {
    var form = box.querySelector('form');
    var tagsEl = form && form.querySelector('[data-notify-tags]');
    if (!form || !tagsEl) return;
    var wa = box.querySelector('[data-notify-wa]');
    function slug(v) { return String(v).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function pick(name) { return form.querySelector('[name="' + name + '"]:checked') || form.querySelector('input[type=hidden][name="' + name + '"]'); }
    function sync() {
      var c = pick('notify-color'), sz = form.querySelector('[name="notify-size"]:checked');
      var handle = c ? c.value : '';
      var tags = ['notify-me'];
      if (handle) tags.push('notify-' + handle);
      if (sz) { if (handle) tags.push('notify-' + handle + '-' + slug(sz.value)); tags.push('notify-size-' + slug(sz.value)); }
      tagsEl.value = tags.join(', ');
      if (wa) {
        var title = (c && c.getAttribute('data-title')) || box.getAttribute('data-label');
        var text = 'Hi AND! Please notify me when ' + title + (sz ? ' (size ' + sz.value + ')' : '') + ' is live.';
        wa.href = 'https://wa.me/' + box.getAttribute('data-wa') + '?text=' + encodeURIComponent(text);
      }
    }
    form.addEventListener('change', sync);
    sync();
    if (wa) wa.addEventListener('click', function (e) {
      var first = form.querySelector('[name="notify-size"]');
      if (first && !form.querySelector('[name="notify-size"]:checked')) {
        e.preventDefault();
        if (first.reportValidity) first.reportValidity();
      }
    });
  });

  /* ---------- Notify-me boxes: show "you're on the list" only on the box that was sent ---------- */
  (function () {
    if (!/[?&]customer_posted=true/.test(location.search) || !location.hash) return;
    var id = decodeURIComponent(location.hash.slice(1));
    $$('[data-notify]').forEach(function (box) {
      if (box.getAttribute('data-notify') !== id) return;
      var form = box.querySelector('form'), ok = box.querySelector('[data-notify-ok]');
      if (form) form.hidden = true;
      if (ok) ok.hidden = false;
    });
  })();

  /* ---------- Campaign countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var raw = el.getAttribute('data-countdown').trim().replace(' ', 'T');
    var end = new Date(raw + (raw.length <= 16 ? ':00' : '') + '+02:00').getTime();
    if (isNaN(end)) return;
    var parts = {};
    $$('[data-cd]', el).forEach(function (b) { parts[b.getAttribute('data-cd')] = b; });
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (!left) { el.hidden = true; return false; }
      var sec = Math.floor(left / 1000);
      parts.d.textContent = Math.floor(sec / 86400);
      parts.h.textContent = pad(Math.floor(sec % 86400 / 3600));
      parts.m.textContent = pad(Math.floor(sec % 3600 / 60));
      parts.s.textContent = pad(sec % 60);
      el.hidden = false;
      return true;
    }
    if (tick()) { var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000); }
  });

  /* ---------- Product carousels ---------- */
  $$('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var bar = root.querySelector('[data-carousel-bar]');
    var prev = root.querySelector('[data-carousel-prev]'), next = root.querySelector('[data-carousel-next]');
    function step() { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 16 : track.clientWidth; }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max > 0 ? track.scrollLeft / max : 1;
      if (bar) { bar.style.width = Math.max(track.clientWidth / track.scrollWidth, 0.12) * 100 + '%'; bar.style.transform = 'translateX(' + (ratio * (100 / Math.max(track.clientWidth / track.scrollWidth, 0.12) - 100)) + '%)'; }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      root.classList.toggle('is-static', max <= 2);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- Quick add on product cards ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      e.preventDefault();
      var q = toggle.closest('[data-quick]');
      var open = !q.classList.contains('is-open');
      $$('[data-quick].is-open').forEach(function (o) { o.classList.remove('is-open'); var b = o.querySelector('[data-quick-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); });
      q.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var add = e.target.closest('[data-quick-add]');
    if (add) {
      e.preventDefault();
      var wrap = add.closest('[data-quick]');
      add.classList.add('is-loading');
      fetch(AND.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +add.getAttribute('data-quick-add'), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { if (wrap) wrap.classList.remove('is-open'); return refreshCart(true); })
        .catch(function (er) { add.textContent = 'Sold out'; add.disabled = true; })
        .finally(function () { add.classList.remove('is-loading'); });
      return;
    }
    if (!e.target.closest('[data-quick]')) $$('[data-quick].is-open').forEach(function (o) { o.classList.remove('is-open'); });
  });

  /* ---------- Delivery estimate ---------- */
  $$('[data-eta]').forEach(function (el) {
    var off = String(AND.offDays || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return !isNaN(n); });
    function addWorkingDays(d, n) {
      var r = new Date(d);
      while (n > 0) { r.setDate(r.getDate() + 1); if (off.indexOf(r.getDay()) === -1) n--; }
      return r;
    }
    var now = new Date();
    var a = addWorkingDays(now, AND.deliveryMin || 1);
    var b = addWorkingDays(now, AND.deliveryMax || 3);
    var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
    el.innerHTML = 'Order now, get it <b>' + fmt(a) + (b - a > 0 ? ' – ' + fmt(b) : '') + '</b>';
  });

  /* ---------- Contact / waitlist forms ---------- */
  $$('form[data-waitlist]').forEach(function (f) {
    if (window.location.search.indexOf('contact_posted=true') !== -1 && window.location.hash === '#' + f.id) {
      var m = f.querySelector('.form-msg');
      if (m) { m.hidden = false; m.textContent = "You're on the list. We'll message you the moment it's back."; }
    }
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        // carousel rows reveal as one, so cards off to the side don't fade in on swipe
        var track = e.target.closest('[data-carousel-track]');
        var els = track ? $$('[data-reveal]', track) : [e.target];
        els.forEach(function (el) { el.classList.add('is-in'); io.unobserve(el); });
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
})();
